module.exports = __webpack_public_path__ + "img/wp-existing-habit-card9.33639cb0.jpg";